import * as Api from "@/api/socket";
import * as Local from "./broker";

export function init() {
  Local.init();
}

enum ApiSignal {
  AssignmentsCount = "api:assignments_count",
  ReloadComments = "api:reload_comments",
  UnreadNotificationCount = "api:unread_notifications_count",
  ProfileUpdated = "api:profile_updated",
  BillingUpdated = "api:billing_updated",
  NewAgentMessage = "api:new_agent_message",
  ReloadFeed = "api:reload_feed",
  ReloadContacts = "api:reload_contacts",
}

export enum LocalSignal {
  RefreshReviewCount = "local:refresh_review_count",
  RefreshNotificationCount = "local:refresh_notification_count",
  RefreshSpaceData = "local:refresh_space_data",
}

export function publish(event: LocalSignal) {
  Local.publish(event);
}

export function useAssignmentsCount(callback: () => void) {
  return Api.useSubscription(ApiSignal.AssignmentsCount, callback);
}

export function useReloadCommentsSignal(callback: () => void, payload: { resourceId: string }) {
  return Api.useSubscription(ApiSignal.ReloadComments, callback, payload);
}

export function useUnreadNotificationCount(callback: () => void) {
  return Api.useSubscription(ApiSignal.UnreadNotificationCount, callback);
}

export function useProfileUpdatedSignal(callback: () => void) {
  return Api.useSubscription(ApiSignal.ProfileUpdated, callback);
}

export function useBillingUpdatedSignal(callback: () => void) {
  return Api.useSubscription(ApiSignal.BillingUpdated, callback);
}

export function useReviewRefreshSignal(callback: () => void) {
  return Local.useSubscription(LocalSignal.RefreshReviewCount, callback);
}

export function useNotificationRefreshSignal(callback: () => void) {
  return Local.useSubscription(LocalSignal.RefreshNotificationCount, callback);
}

// Fired by the space landing page when live space activity arrives, so each tile
// that owns its own query (Activity feed, Contacts) can refetch in place.
export function useSpaceDataRefreshSignal(callback: () => void) {
  return Local.useSubscription(LocalSignal.RefreshSpaceData, callback);
}

export function useNewAgentMessageSignal(callback: () => void, payload: { convoId: string }) {
  return Api.useSubscription(ApiSignal.NewAgentMessage, callback, payload);
}

export function useReloadFeedSignal(callback: () => void, payload: { resourceId: string }) {
  return Api.useSubscription(ApiSignal.ReloadFeed, callback, payload);
}

// Company-wide CRM book changed (a contact was saved anywhere in the company).
// No payload — the channel is scoped to the socket's company.
export function useReloadContactsSignal(callback: () => void) {
  return Api.useSubscription(ApiSignal.ReloadContacts, callback);
}
